export default "__VITE_ASSET__Cix1XN5a__"